export default __webpack_public_path__ + "static/media/e-sport-3.62e40078.png";